import clsx from "clsx"
import { z } from "zod"

export const infoLeftRightSchema = z.object({
	component: z.literal("info-left-right"),
	image: z.string(),
	title: z.string(),
	subtitle: z.string(),
	left: z.boolean().default(false),
})

type InfoLeftRightProps = z.infer<typeof infoLeftRightSchema>

export default function InfoLeftRight(
	props: InfoLeftRightProps
) {
	const { image, title, subtitle, left } = props

	return (
		<div className="flex w-full justify-center py-[60px]">
			<div
				className={clsx(
					left
						? "desktop:flex-row"
						: "desktop:flex-row-reverse",
					"flex flex-col items-center desktop:w-[606px] desktop:justify-between"
				)}>
				<div className="flex flex-col items-center gap-[22px]">
					<h3
						className={clsx(
							"w-[232px] text-center text-[24px] font-700 text-color-black",
							"desktop:w-[295px] desktop:text-start whitespace-pre-line"
						)}>
						{title}
					</h3>

					<img
						className="h-[152px] w-[285px] rounded-[9px] desktop:hidden"
						alt="info lefit"
						src={image}
					/>

					<p
						className={clsx(
							"w-[339px] text-center text-[18px] font-400 text-blue-700",
							"desktop:w-[295px] desktop:text-start"
						)}>
						{subtitle}
					</p>
				</div>

				<img
					src={image}
					alt="image"
					className="hidden h-[144px] w-[270px] rounded-[7px] desktop:flex"
				/>
			</div>
		</div>
	)
}
